module.exports = __webpack_public_path__ + "img/26400.c34960d0.jpg";